import { IServiceTypeAudit } from './service-type-dto.interface';

export interface ICreateMeasureUnitDto {
    /** Unique per organization. Not editable once created. */
    code: string;
    name: string;
    abbreviation?: string | null;
}

/** `code` is intentionally excluded: it cannot be changed after creation. */
export type IUpdateMeasureUnitDto = Partial<Omit<ICreateMeasureUnitDto, 'code'>>;

export interface IMeasureUnitOutputDto {
    id: string;
    code: string;
    name: string;
    abbreviation?: string | null;
    createdBy?: IServiceTypeAudit;
    updatedBy?: IServiceTypeAudit;
    createdAt?: string;
    updatedAt?: string;
}
